import React, { useState } from 'react';
import { Link } from 'react-scroll';
import Headroom from 'react-headroom';
import './Navbar.css';

const Navbar = () => {
	const [activeLink, setActiveLink] = useState();
	const [menuOpen, setMenuOpen] = useState(false); // State for menu toggle

	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};

	return (
		<Headroom style={{ zIndex: 2 }}>
			<nav className="navbarContainer">
				<div className="logoSection">
					<img className='logoImg' src={process.env.PUBLIC_URL + '/assets/logo.png'} alt="ROBOTICITMS" />
					<h1 className="logoText">ETOS</h1>
				</div>
				<ul className={`navLinks ${menuOpen ? 'open' : ''}`}>
					<li className="navItem">
						<Link
							to="hero"
							smooth={true}
							offset={-110}
							duration={500}
							className={activeLink === 'about' ? 'active' : ''}
							onClick={() => { setActiveLink('about'); setMenuOpen(false); }}
						>About</Link>
					</li>
					<li className="navItem">
						<Link
							to="resources"
							smooth={true}
							offset={-110}
							duration={500}
							className={activeLink === 'Resources' ? 'active' : ''}
							onClick={() => { setActiveLink('Resources'); setMenuOpen(false); }}
						>Resources</Link>
					</li>
					<li className="navItem">
						<Link
							to="products"
							smooth={true}
							offset={-110}
							duration={500}
							className={activeLink === 'Products' ? 'active' : ''}
							onClick={() => { setActiveLink('Products'); setMenuOpen(false); }}
						>Products</Link>
					</li>
					<li className="navItem">
						<Link
							to="contact"
							smooth={true}
							offset={-110}
							duration={500}
							className={activeLink === 'Contact' ? 'active' : ''}
							onClick={() => { setActiveLink('Contact'); setMenuOpen(false); }}
						>Contact</Link>
					</li>
				</ul>
				<div className={`hamburger ${menuOpen ? 'is-active' : ''}`} onClick={toggleMenu}>
					<div className={`bar ${menuOpen ? 'open' : ''}`}></div>
					<div className={`bar ${menuOpen ? 'open' : ''}`}></div>
					<div className={`bar ${menuOpen ? 'open' : ''}`}></div>
				</div>
			</nav>
		</Headroom>
	);
};

export default Navbar;
